import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M112 0H0V112H112V0Z",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M72.3335 30.3333H39.6668C34.5122 30.3333 30.3335 34.512 30.3335 39.6666V72.3333C30.3335 77.488 34.5122 81.6666 39.6668 81.6666H72.3335C77.4882 81.6666 81.6668 77.488 81.6668 72.3333V39.6666C81.6668 34.512 77.4882 30.3333 72.3335 30.3333Z",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24.22 61.9267C24.3509 62.0333 24.5094 62.1003 24.677 62.1199C24.8446 62.1396 25.0144 62.1109 25.1663 62.0374C25.3182 61.9639 25.446 61.8486 25.5346 61.705C25.6233 61.5613 25.6691 61.3954 25.6667 61.2267V50.7733C25.6691 50.6046 25.6233 50.4386 25.5346 50.295C25.446 50.1514 25.3182 50.0361 25.1663 49.9625C25.0144 49.889 24.8446 49.8604 24.677 49.88C24.5094 49.8997 24.3509 49.9667 24.22 50.0733L17.6867 55.3C17.5801 55.3829 17.4938 55.489 17.4344 55.6104C17.3751 55.7317 17.3442 55.8649 17.3442 56C17.3442 56.135 17.3751 56.2683 17.4344 56.3896C17.4938 56.5109 17.5801 56.6171 17.6867 56.7L24.22 61.9267Z",
      fill: "#959FEB"
    }, null, -1),
    _createElementVNode("path", {
      d: "M87.7798 61.9267C87.6489 62.0333 87.4904 62.1003 87.3228 62.1199C87.1551 62.1396 86.9854 62.1109 86.8335 62.0374C86.6816 61.9639 86.5538 61.8486 86.4651 61.705C86.3765 61.5613 86.3307 61.3954 86.3331 61.2267V50.7733C86.3307 50.6046 86.3765 50.4386 86.4651 50.295C86.5538 50.1514 86.6816 50.0361 86.8335 49.9625C86.9854 49.889 87.1551 49.8604 87.3228 49.88C87.4904 49.8997 87.6489 49.9667 87.7798 50.0733L94.3131 55.3C94.4197 55.3829 94.506 55.489 94.5653 55.6104C94.6247 55.7317 94.6555 55.8649 94.6555 56C94.6555 56.135 94.6247 56.2683 94.5653 56.3896C94.506 56.5109 94.4197 56.6171 94.3131 56.7L87.7798 61.9267Z",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }